import React, { memo } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n';

type Props = {
    titleId: string;
    navigation: React.ReactNode;
    breadcrumbs: React.ReactNode;
    selectionButton?: React.ReactNode;
}

export const MainLayoutHeader = memo(({ titleId, navigation, breadcrumbs, selectionButton }: Props) => (
    <div
        className="vss-main-layout-header"
    >
        <div className="vss-main-layout-header__title">
            <I18n messageId={titleId}/>

            {selectionButton}
        </div>

        {breadcrumbs}

        {navigation}
    </div>
));
